// src/features/counter/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { sortBranchesPutTestLast } from "@helpers/sortBranchesPutTestLast";

export const mobileHelperSlice = createSlice({
  name: 'mobileHelper',
  initialState: {
    token: null,
    currentBranchId: null,
    position: "",           // 職稱
    name: "",               // 姓名
    branchName: "",         // 當前分店名稱
    branchList: [],         // 該員工所屬 所有分店 和 所屬醫生
  },
  reducers: {
    setMobileHelper(state, action) {
      const { data, branchIdList, branchId, role, employeeInfo, branchName } = action.payload;
      const safeBranchList = sortBranchesPutTestLast(branchIdList || []);
      const activeBranchId = branchId || employeeInfo?.employeeBranchId || safeBranchList[0]?.branchId || safeBranchList[0]?.branch_id || safeBranchList[0]?.id;
      const activeBranch = safeBranchList.find((branch) => (
        String(branch.branchId ?? branch.branch_id ?? branch.id) === String(activeBranchId)
      ));
      const serverPosition = role === 'doctor' ? '醫生' :
        role === 'employee' ? '員工' : '員工'

      state.token = data;
      state.branchList = safeBranchList;
      state.currentBranchId = activeBranchId;
      state.position = serverPosition
      state.name = employeeInfo.employeeName
      state.branchName = branchName || activeBranch?.branchName || activeBranch?.branch_name || safeBranchList[0]?.branchName || ""
    },
    clearMobileHelper(state) {
      state.data = null;
      state.branchIdList = [];
    },
    setToken(state, action) {
      const { token, branchId, branchName } = action.payload;
      state.token = token || "";
      state.currentBranchId = branchId || "";
      state.branchName = branchName || "";
    },
  },
});

export const { setMobileHelper, clearMobileHelper, setToken } = mobileHelperSlice.actions;

export default mobileHelperSlice.reducer;
